<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="photo" slot-scope="params">
        <el-image v-if="params.params.car_image && params.params.car_image[0]" :src="params.params.car_image[0].url"
          :preview-src-list="params.params.urls"></el-image>
        <span v-if="!params.params.car_image || !params.params.car_image[0]">-</span>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "VehicleExpatriate",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "hirecar",
      getOptionUrl: 'addpro',
      title: "添加",
      breadcrumb: [
        { name: "承运管理" },
        { name: "外协车辆" },
      ],
      formInline: {},
      viewMode: false,
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "所属承运公司",
          keyName: "company",
          placeholder: "请填写公司名称",
          type: "text",
        },
      ],
      mform: {
        license: undefined,
        pcusid: undefined,
        driver: undefined,
        phone: undefined,
      },
      mrules: {
        license: [
          {
            required: true,
            validator: this.checkLicense,
            trigger: 'blur',
          }
        ],
        company: [
          {
            required: true,
            message: '请填写所属承运公司',
            trigger: 'blur',
          }
        ],
        pcusid: [
          {
            required: true,
            message: '请选择所属承运公司',
            trigger: 'blur',
          }
        ],
        driver: [
          {
            required: true,
            message: '请填写司机姓名',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
      },
      mformCtrl: [
        {
          label: "所属承运公司",
          // keyName: "company",
          keyName: "pcusid",
          err: "请选择所属承运公司",
          type: "select",
          options: [],
        },
        // {
        //   label: "承运联系人",
        //   keyName: "pcusid",
        //   err: "请选择承运联系人",
        //   type: "select",
        //   options: [],
        // },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
        {
          label: "挂车号",
          keyName: "trailer",
          err: "请填写挂车号",
          type: "text",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: []
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "核定载重(吨)",
          keyName: "ton",
          err: "请填写核定载重",
          type: "number",
        },
        {
          label: "车辆照片",
          keyName: "car_image",
          type: "file",
          ptype: "car",
          tips: "最多上传10张图片",
          max: 10,
        },
      ],
      cols: [
        { keyName: "company", label: "所属承运公司", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "trailer", label: "挂车号", minwidth: 120 },
        { keyName: "vtype", label: "车辆类型", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "phone", label: "联系电话", minwidth: 120 },
        { keyName: "ton", label: "核定载重(吨)", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // this.title = "外协车辆编辑";
            // this.getData(id);
            this.$router.push(
              `/carrier/hirecardetail?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
    };
  },
  methods: {
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const { count, data } = res
        this.total = count
        if (data && data.length) {
          this.tableData = data.map(v => {
            const obj = this.dataObjHandler(v)
            obj.urls = []
            // console.log({ ...obj })
            obj.car_image && obj.car_image.map(o => {
              obj.urls.push(o.url)
            })
            return obj
          })
        }
      }
    },
    addItem() {
      // this.title = '外协车辆添加'
      // this.mform = {
      //   license: '',
      //   pcusid: undefined,
      //   driver: '',
      //   phone: '',
      // };
      // this.showDialog();
      this.$router.push(
        `/carrier/hirecardetail?mode=add`
      );
    },
    getData(id) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        userid: this.user.id,
        id,
      };
      this.mform['id'] = id
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
              this.showDialog();
            });
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    setOptions({ pcustom, car_type }) {
      this.mformCtrl.map(v => {
        if (v.keyName == 'pcusid' && pcustom && pcustom.length) {
          v.options = pcustom.map(val => {
            return {
              label: val.company,
              value: val.id,
            }
          })
        } else if (v.keyName == 'vtype' && car_type && car_type.length) {
          v.options = car_type.map(val => {
            return {
              label: val.name,
              value: val.name,
            }
          })
        }
      })
    },
  },
  mounted() {
    this.getOptions();
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }

  }

  .modal-scroll {
    height: 500px;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .is-horizontal {
      display: none;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.el-image {
  max-width: 80px;
  max-height: 80px;
}
</style>